// Trial Balance Actions
import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get trial balance list from backend then update trialBalanceList in vuex store ***** //
export const fetchTrialBalanceList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      date: payload.date,
      outlet_id: payload.outlet_id
    }
  }

  try {
    const result = await Axios.get(`report_trial_balance`, { params: params })
    commit('setTrialBalanceList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}
